import Vue from 'vue';

export default {

  async fetchDprs({ commit }, { pId, vId, startDate, endDate }) {
    Vue.$log.debug('loading dpr for', pId, vId, 'with start date', startDate, 'with end date', endDate);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '')
    query += '&startDate=' + (startDate || '') + '&endDate=' + (endDate || '');

    return Vue.axios.get(Vue.$url("dpr-search" + query))
      .then((rsp) => { 
        commit("SET_DPR", rsp.data)
        return rsp.data;
      });
  },

  async fetchDprFiles({ commit }, { mainId }) {
    Vue.$log.debug('loading pdf files for ', mainId);

    let dprMainId = mainId || '00000000-0000-0000-0000-000000000000';
    return Vue.axios.get(Vue.$url("dpr-search/" + dprMainId + "/files"))
      .then((rsp) => commit("SET_DPR_FILES", rsp.data));
  },

}